import React from 'react';
import WmwSection8a from '../../../../../components/course/churchschool/wmw/WmwSection8a';
import JepsplSection from '../../../../../components/course/churchschool/JepsplSection';
import WarningSection from '../../../../../components/course/churchschool/WarningSection';
import WmwSection14 from '../../../../../components/course/churchschool/wmw/WmwSection14';
import GodDealWeekSectionOct, {
  IS_DISPLAY_GODDEAL_SECTION,
} from '../../../../../components/course/churchschool/event/GodDealWeekSectionOct';

const BoostupWmwBookMain = () => {
  return (
    <>
      {IS_DISPLAY_GODDEAL_SECTION && <GodDealWeekSectionOct />}
      <WmwSection8a />
      <WarningSection />
      <JepsplSection />
      <WmwSection14 />
    </>
  );
};

export default BoostupWmwBookMain;
